import styled from "@emotion/styled";
import colors from "src/styles/variables.scss";

export interface ILandscapeSection {
  height: number;
  width: number;
}
export interface ILandscapeContainer {
  height: number;
}

export const LandscapeSection = styled.section<ILandscapeSection>`
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LandscapeTextHead = styled.span`
  margin-top: 3%;
  height: 24px;
  font-family: Arial, "sans-serif";
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.71px;
  color: #ffffff;
`;

export const LandscapeTextTail = styled.span`
  margin-top: 1.4%;
  height: 14px;
  opacity: 0.75;
  font-family: Arial, "sans-serif";
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.73px;
  color: #ffffff;
`;

export const LandscapeContainer = styled.div<ILandscapeContainer>`
  height: ${({ height }) => height}px!important;
  height: 100%;
  width: 100%;
  background-color: ${colors.rotatedDeviceBackground};
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;
